<h2 i18n>Create View</h2>
<mat-form-field class="control">
  <mat-label i18n>View Name</mat-label>
  <input matInput required [formControl]="name">
  @if (name.hasError('required')) {
    <mat-error i18n>You must provide a name for this view</mat-error>
  }
</mat-form-field>
<div class="buttons">
  <button mat-button (click)="cancel()" i18n>CANCEL</button>
  <button mat-button [disabled]="name.invalid" (click)="submit()" i18n>CREATE</button>
</div>
